import { useState } from "react";
import { Megaphone, Radio, Code2, Plane, Coffee } from "lucide-react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Reveal } from "../components/site/Reveal";
import { EnquiryForm } from "../components/site/EnquiryForm";
import { useTitle } from "../App";

const TYPES = [
  { key: "brand", icon: Megaphone, title: "Brands", text: "You have something to sell and a growth target to hit. We plan acquisition, creative and measurement around your economics." },
  { key: "publisher", icon: Radio, title: "Publishers & Affiliates", text: "Quality traffic deserves serious advertisers. We build structured CPS, CPL and CPA programmes with proper validation and reporting." },
  { key: "technology", icon: Code2, title: "Technology Collaborators", text: "Tools, data and integrations that strengthen MediaOS or our clients' marketing operations are worth a conversation." },
  { key: "travel", icon: Plane, title: "Travel Partners", text: "Operators, stays and experience providers who care about journeys done well — our travel venture is building its network now." },
  { key: "hospitality", icon: Coffee, title: "Cafe & Hospitality Partners", text: "Operators, spaces and F&B collaborators interested in our upcoming cafe and hospitality concept." },
];

export default function Partnerships() {
  useTitle("Partnerships");
  const [selected, setSelected] = useState(TYPES[0]);

  return (
    <div data-testid="partnerships-page" className="bg-midnight text-mist">
      <Navbar />
      <section className="grain pt-[76px]">
        <div className="container-ek py-24 sm:py-28">
          <Reveal className="mx-auto max-w-3xl text-center">
            <p className="eyebrow mb-4">Partnerships</p>
            <h1 className="font-display text-4xl font-bold tracking-tight sm:text-6xl">Good ventures are rarely built alone.</h1>
            <p className="mt-6 text-base leading-relaxed text-slate-400 sm:text-lg">
              Ekavrix works with partners across its three pillars. Choose where you fit, tell us what you have in mind, and we will respond with substance.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 sm:pb-32">
        <div className="container-ek grid gap-10 lg:grid-cols-12">
          <div className="space-y-4 lg:col-span-6">
            {TYPES.map((t, i) => (
              <Reveal key={t.key} delay={i * 0.06}>
                <button data-testid={`partner-type-${t.key}`} onClick={() => setSelected(t)} aria-pressed={selected.key === t.key}
                  className={`card-dark w-full p-6 text-left transition-[border-color] duration-300 ${selected.key === t.key ? "border-violet/50" : ""}`}>
                  <div className="flex items-center gap-4">
                    <t.icon size={22} className={selected.key === t.key ? "text-violet" : "text-teal"} />
                    <h2 className="font-display text-lg font-semibold">{t.title}</h2>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{t.text}</p>
                </button>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15} className="lg:col-span-6">
            <div className="card-dark sticky top-28 p-7 sm:p-10">
              <EnquiryForm title={`Partnership enquiry — ${selected.title}`} defaultCategory="partnership" venture={`partnership:${selected.key}`} sourcePage="/partnerships" />
            </div>
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
}
